import { GeneralAPI } from '../apis/GeneralAPI'
import BookACallFunnelButton from '../components/Buttons/Specials/BookACallFunnelButton'
import CallAction from '../components/Coaching/CallAction'
import CampaignStrategy from '../components/Coaching/CampaignStrategy'
import Effective from '../components/Coaching/Effective'
import FreeOffers from '../components/Coaching/Funnel/FreeOffers'
import HeroBanner from '../components/Coaching/Funnel/HeroBanner'
import ListBuildingFunnel from '../components/Coaching/ListBuildingFunnel'
import Support from '../components/Coaching/Support'
import Technology from '../components/Coaching/Technology'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Badge from '../components/HomePage/Badge'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import SectionHeading from '../components/HomePage/SectionHeading'

function CoachingFunnel({ data }) {
    return (
        <LandingPageWrapper>
            <Header
                metaTitle={'Coaching | Open Letter Marketing'}
                meta={data?.yoast_head}
            />
            <HeroBanner />
            <Badge hasHeading={false} />
            <CampaignStrategy
                size="xl"
                superHeading={
                    <div className="pt-20 w-9/12 m-auto md:w-full">
                        <SectionHeading>
                            What You Get with Our{' '}
                            <span className="olm-gradient-text">
                                Coaching Call
                            </span>{' '}
                        </SectionHeading>
                    </div>
                }
            />
            <ListBuildingFunnel
                callAction={true}
                CallActionButton={BookACallFunnelButton}
                size="xl"
            />
            <Effective size="xl" />
            <Technology size="xl" />
            <Support size="xl" shouldAddFooter={false} />
            <FreeOffers />
            <CallAction CallActionButton={BookACallFunnelButton} />
            <Footer />
        </LandingPageWrapper>
    )
}

export default CoachingFunnel

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/free-coaching-call')
    const data = page ? page[0] : {}
    return {
        props: { data },
        revalidate: 10, // In seconds
    }
}
